import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 1080 1080"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "100%",
      height: "100%",
      fill: "transparent"
    }, null, -1),
    _createElementVNode("path", {
      "stroke-linecap": "round",
      d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0M4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.9 17.9 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632",
      style: {"stroke":"currentColor","stroke-width":"1.5","stroke-dasharray":"none","stroke-linecap":"round","stroke-dashoffset":"0","stroke-linejoin":"round","stroke-miterlimit":"4","fill":"none","fill-rule":"nonzero","opacity":"1"},
      transform: "translate(-57.46)scale(45)"
    }, null, -1),
    _createElementVNode("path", {
      "stroke-linecap": "round",
      d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75",
      style: {"stroke":"currentColor","stroke-width":"3","stroke-dasharray":"none","stroke-linecap":"round","stroke-dashoffset":"0","stroke-linejoin":"round","stroke-miterlimit":"4","fill":"none","fill-rule":"nonzero","opacity":"1"},
      transform: "translate(725.29 299.43)scale(14.68)"
    }, null, -1)
  ]))]))
}
export default { render: render }